// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q3Id","comment":"styles_comment__30D93"};